<template>
    <v-card width="344" ma-0 pa-0 :dark="nightly" :color="nightly ? 'grey lighten-1' : 'white'" elevation="1">
        <v-list-item two-line @click="open(url)" @mousedown.middle="openInNewTab(url)">
            <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                    {{ title }}
                    <v-icon>mdi-link</v-icon>
                </v-list-item-title>
                <v-spacer />
                <v-list-item-subtitle v-if="version">
                    <v-icon small>mdi-update</v-icon>
                    {{ version }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="updatedOn">
                    <v-icon small>mdi-calendar</v-icon>
                    {{ updatedOn }}
                </v-list-item-subtitle>
            </v-list-item-content>
            <slot name="logo"></slot>
        </v-list-item>

        <v-card-actions>
            <v-btn v-if="!noShareLink" class="text-capitalize" @click="open(bormShareUrl)"  @mousedown.middle="openInNewTab(bormShareUrl)" rounded text color="primary" @click.stop="">
                BormShare
                <v-icon>mdi-link</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn class="text-capitalize" @click="showQrCode = !showQrCode" rounded text color="primary" @click.stop="">
                BormApp
                <v-icon>mdi-qrcode</v-icon>
            </v-btn>
        </v-card-actions>

        <v-expand-transition>
            <div v-show="showQrCode" class="text-center">
                <v-divider></v-divider>
                <qrcode-vue :value="bormAppQrCodeValue" :size="qrCodeSize" level="H" renderAs="svg" class="qrcode" />
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
    components: {
        QrcodeVue,
    },
    name: "LiveEntry",
    props: {
        title: String,
        url: String,
        version: String,
        updatedOn: String,
        logoUrl: String,
        noShareLink: Boolean,
        nightly: Boolean,
    },
    methods: {
        open(url) {
            window.location.href = url;
        },
        openInNewTab(url) {
            window.open(url, '_blank').focus();
        },
    },
    computed: {
        bormAppQrCodeValue: function() {
            return `BORM:SERVER_SETUP=${this.url}`;
        },
        bormShareUrl: function() {
            return `${this.url}borm-share/#/f295db7f-4636-4d1c-aa7a-ddd8161cf89d`;
        },
    },
    data: () => ({
        qrCodeSize: 150,
        showQrCode: false,
    }),
}
</script>

<style scoped>
.qrcode {
    padding: 16px;
}
</style>
